import { useCustomer } from './customerContext';
import { AuditLogsList } from '../../../audit-log/components/AuditLogsList';

export const CustomerAuditLogsPage = () => {
  const { customer } = useCustomer();

  return <AuditLogsList filter={{ customerId: customer.id }} />;
};
